<template>
  <div class="panel-body">
    <h4 v-if="showUsers.Message">Message: {{ showUsers.Message }}</h4>
    <h1 class="logo-desc">Programming Hub</h1>
    <!-- // card \\-->
    <form @submit.prevent="submit" class="form-container">
      <div class="form-group">
        <label for="exampleInputEmail1">Enter Email address of the user to remove</label>
        <input
          type="email"
          class="form-control"
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          placeholder="Enter email"
          required
          v-model="email"
        />
      </div>
      <button type="submit" class="btn btn-primary w-10" :disabled="loader">
        <span v-if="loader">Loading...</span>
        <span v-else>Submit</span>
      </button>
    </form>
    <div v-if="showMessage || showReason" class="error-box">
      <span v-if="showMessage">
        <span class="title">Message:</span>
        {{showMessage}}
      </span>
      <br />
      <span v-if="showReason">
        <span class="title">Reason:</span>
        {{showReason}}
      </span>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import "vue-loaders/dist/vue-loaders.css";
import * as VueLoaders from "vue-loaders";
Vue.use(VueLoaders);
export default {
  name: "delUser",
  computed: {
    ...mapGetters({
      showData: "showData",
      showUsers: "showUsers",
      showMessage: "showMessage",
      showReason: "showReason",
      loader: "showLoader"
    }),
    searchUser: {
      set: function(val) {
        this.$store.commit("updateSearchUser", val);
      },
      get: function() {
        return this.showData.searchUser;
      }
    }
  },
  mounted() {
    this.modeSet();
    this.resetMessages();
  },
  data() {
    return {
      email: ""
    };
  },
  methods: {
    ...mapActions(["setMode", "delUser", "resetMessages"]),

    modeSet: function() {
      if (localStorage.getItem("Mode")) {
        this.setMode({ mode: localStorage.getItem("Mode") });
      } else {
        this.setMode({ mode: this.showData.mode });
      }
      this.resetMessages();
    },
    submit: function() {
      this.delUser({
        email: this.email,
        mode: this.showData.mode
      });
      this.email = "";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-container {
  margin: 60px auto;
  width: 30%;
}
.w-10 {
  width: 100px;
}
.error-box {
  color: #ff0000;
}
.title {
  color: black;
  font-weight: 900;
}
@media screen and (max-width: 768px) {
  .form-container {
    width: 60%;
  }
}
@media screen and (max-width: 600px) {
  .form-container {
    width: 80%;
  }
}
</style>
